module.exports = __webpack_public_path__ + "front/img/kv05.412e2624.png";